export default {
  en: {
    'all': 'All',
    'avg-weekly-hrs': 'Avg. Weekly Hrs',
    'only-active': 'Only Active',
    'employee-look-back': 'Employee Look Back',
    'search-here': 'Search here',
    'search-instructions': "Search using the first 4 letters of the employee's last name OR the last 4 digits of the employee's SSN. For names shorter than 4 letters, add spaces to reach 4 characters.",
    'employee-lookup': 'Employee Time Punches',
    'please-enter-a-value': 'Please enter a value',
    'please-enter-4-letters': 'Please enter 4 letters',
    'please-enter-4-numbers': 'Please enter 4 numbers',
    'please-do-not-use-special-characters': 'Please do not use any special characters',
    'employees': 'Employees',
    'emp-pay-details': 'Employee Pay Details',
    'federal': 'Fed.',
    'state': 'State',
    'local': 'Local',
    'marital-status': 'Marital Status',
    'tax-exempt': 'Tax Exempt',
    'exemptions': 'Exemptions',
    'additional-withholding': 'Additional Withholding $',
    'fed-multi-job': 'Fed. Multi Job',
    'fed-qual-child': 'Fed. Qual Child $',
    'fed-other-dep': 'Fed. Other Dep $',
    'fed-total-dep': 'Fed. Total Dep $',
    'fed-other-income': 'Fed. Other Income',
    'fed-deductions': 'Fed. Deductions',
    'hire-card-store-num': 'Location',
    'new-hires-since': 'New Hires Since',
    'new-hires-found': 'New Hires Found',
    'new-hires': 'New Hires',
    'overtime-audit': 'Overtime Audit',
    'no-pay-details-found': 'No pay details have been found.',
    'pay-cycle': 'Pay Cycle',
    'pay-cycle-status': 'Pay Cycle Status',
    'current-pay-cycle': 'Current Pay Cycle',
    'most-recent-released': 'Most Recent Released',
    'next-pay-cycle': 'Next Pay Cycle',
    'active-employee-with-no-punches': 'Active Employee With No Punches',
    'employee-terminations': 'Employee Terminations',
    'employee-pay-rate-change': 'Employee Pay Rate Change',
    'employee-leave-of-absence': 'Employee Leave Of Absence',
    'total-employees': 'Total Employees',
    'employee-name': 'Employee Name',
    'employee-full-name': 'Employees full name including middle initial of name if it is entered',
    'first-name': 'First Name',
    'employee-first-name': 'Employees first name',
    'last-name': 'Last Name',
    'employee-last-name': 'Employees last name',
    'ssn': 'SSN',
    'employee-ssn': 'Employee Social Security Number',
    'geid': 'GEID',
    'employee-geid': 'McDonalds Global employee identifier',
    'primary-badge': 'Primary Badge',
    'primary-badge-number': 'Primary badge number',
    'secondary-badge': 'Secondary Badge',
    'secondary-badge-number': 'Secondary badge number',
    'last-punch-date': 'Last Punch Date',
    'last-punch-date-within-3-months': 'Last Punch within 3 months',
    'greater-than-3-months': '> 3 Months',
    'hire-date': 'Hire Date',
    'date-hired': 'Date Hired',
    'termination-date': 'Termination Date',
    'date-of-termination': 'Date of termination',
    'termination-reason': 'Termination Reason',
    'reason-of-termination': 'Reason of termination',
    'termination-code': 'Termination Code',
    'reason-of-termination-code': 'Reason of termination',
    'day-count': 'Day Count',
    'double-time-hours': 'Double Time Hours',
    'amount-of-hours-paid-double-the-regular-rate': 'Amount of hours paid double the regular rate',
    'overtime-hours': 'Over Time Hours',
    'amount-of-hours-paid-pay-and-a-half': 'Amount of hours paid pay and a half',
    'regular-time-hours': 'Regular Time Hours',
    'amount-of-hours-paid-with-normal-pay-rate': 'Amount of hours paid with normal pay rate',
    'total-dollars-paid': 'Total Dollars Paid',
    'amount-of-dollars-paid-during-the-pay-periods': 'Amount of dollars paid during the pay period(s)',
    'start-date': 'Start Date',
    'end-date': 'End Date',
    'pay-periods': 'Pay Periods',
    'start-of-new-pay-rate-and-job-title-code': 'Start of new Pay Rate and Job Title Code',
    'pay-rate': 'Pay Rate',
    'prior-pay-rate': 'Prior Pay Rate',
    'job-title-code': 'Job Title Code',
    'prior-job-title-code': 'Prior Job Title Code',
    'start-of-leave-of-absence': 'Start of leave of absence',
    'projected-return': 'Projected Return',
    'projected-return-of-leave-of-absence': 'Projected return of leave of absence',
    'actual-return': 'Actual Return',
    'actual-return-of-leave-of-absence': 'Actual return of leave of absence',
    'reason': 'Reason',
    'job-title-code-description-description': 'McDonalds Job Title Code Description',
    'job-title-code-description-header': 'Job Title Code Description',
    'date-of-birth-header': 'Date Of Birth',
    'date-of-birth-description': "Employee's date of birth",
    'street-address': 'Street Address',
    'city': 'City',
    'zip-code': 'Zip Code',
    'apt-number': 'Apt Number',
    'error-loading-report': 'There was an error loading the report.',
    'pay-period-end-date': 'Pay Period End Date',
    'payroll-ledger': 'Payroll Ledger',
    'omit-managers': 'Omit Managers',
    'show-documents-expiring-in-the-next': 'Show Documents Expiring In The Next',
    'day-scope': 'Day(s)',
    'week-scope': 'Week(s)',
    'month-scope': 'Month(s)',
    'scope': 'Scope',
    'student-permit-status-check': 'Student Permit Status Check',
    'date': 'Date',
    'less-than-20': 'Less Than 20',
  },
  es: {
    'all': 'Todos',
    'avg-weekly-hrs': 'Promedio de Horas Semanales',
    'only-active': 'Solo Activos',
    'employee-look-back': 'Revisión de Empleados',
    'search-here': 'Buscar aquí',
    'search-instructions': 'Busque utilizando las primeras 4 letras del apellido del empleado O los últimos 4 dígitos del SSN del empleado. Para apellidos de menos de 4 letras, agregue espacios hasta alcanzar 4 caracteres.',
    'employee-lookup': 'Búsqueda de Empleados',
    'please-enter-a-value': 'Por favor ingrese un valor',
    'please-enter-4-letters': 'Por favor ingrese 4 letras',
    'please-enter-4-numbers': 'Por favor ingrese 4 números',
    'please-do-not-use-special-characters': 'Por favor no use caracteres especiales',
    'employees': 'Empleados',
    'emp-pay-details': 'Detalles de Pago del Empleado',
    'federal': 'Fed.',
    'state': 'Estado',
    'local': 'Local',
    'marital-status': 'Estado Civil',
    'tax-exempt': 'Exento de Impuestos',
    'exemptions': 'Exenciones',
    'additional-withholding': 'Retención Adicional $',
    'fed-multi-job': 'Fed. Multi Trabajo',
    'fed-qual-child': 'Fed. Niño Calificado $',
    'fed-other-dep': 'Fed. Otro Dep $',
    'fed-total-dep': 'Fed. Total Dep $',
    'fed-other-income': 'Fed. Otro Ingreso',
    'fed-deductions': 'Fed. Deducciones',
    'hire-card-store-num': 'Ubicación',
    'new-hires-since': 'Nuevas Contrataciones Desde',
    'new-hires-found': 'Nuevas Contrataciones Encontradas',
    'new-hires': 'Nuevas Contrataciones',
    'overtime-audit': 'Auditoría de Horas Extras',
    'no-pay-details-found': 'No se encontraron detalles de pago.',
    'pay-cycle': 'Ciclo de Pago',
    'pay-cycle-status': 'Estado del Ciclo de Pago',
    'current-pay-cycle': 'Ciclo de Pago Actual',
    'most-recent-released': 'Más Reciente Liberado',
    'next-pay-cycle': 'Próximo Ciclo de Pago',
    'active-employee-with-no-punches': 'Empleado Activo sin Registros de Tiempo',
    'employee-terminations': 'Terminaciones de Empleados',
    'employee-pay-rate-change': 'Cambio de Tarifa de Pago del Empleado',
    'employee-leave-of-absence': 'Licencia de Ausencia del Empleado',
    'total-employees': 'Total de Empleados',
    'employee-name': 'Nombre del Empleado',
    'employee-full-name': 'Nombre completo del empleado, incluido el segundo nombre si está ingresado',
    'first-name': 'Primer Nombre',
    'employee-first-name': 'Primer nombre del empleado',
    'last-name': 'Apellido',
    'employee-last-name': 'Apellido del empleado',
    'ssn': 'Número de Seguro Social',
    'employee-ssn': 'Número de Seguro Social del Empleado',
    'geid': 'Identificador global de empleados de McDonalds (GEID)',
    'employee-geid': 'Identificador global de empleados de McDonalds',
    'primary-badge': 'Insignia Principal',
    'primary-badge-number': 'Número de insignia principal',
    'secondary-badge': 'Insignia Secundaria',
    'secondary-badge-number': 'Número de insignia secundaria',
    'last-punch-date': 'Última Fecha de Registro de Entrada',
    'last-punch-date-within-3-months': 'Último Registro de Entrada dentro de 3 meses',
    'greater-than-3-months': '> 3 Meses',
    'hire-date': 'Fecha de Contratación',
    'date-hired': 'Fecha de Contratación',
    'termination-date': 'Fecha de Terminación',
    'date-of-termination': 'Fecha de terminación',
    'termination-reason': 'Motivo de Terminación',
    'reason-of-termination': 'Motivo de terminación',
    'termination-code': 'Código de Terminación',
    'reason-of-termination-code': 'Código de motivo de terminación',
    'day-count': 'Cantidad de Días',
    'double-time-hours': 'Horas de Tiempo Doble',
    'amount-of-hours-paid-double-the-regular-rate': 'Cantidad de horas pagadas al doble de la tarifa regular',
    'overtime-hours': 'Horas Extras',
    'amount-of-hours-paid-pay-and-a-half': 'Cantidad de horas pagadas a tiempo y medio',
    'regular-time-hours': 'Horas de Tiempo Regular',
    'amount-of-hours-paid-with-normal-pay-rate': 'Cantidad de horas pagadas con tarifa normal',
    'total-dollars-paid': 'Total de Dólares Pagados',
    'amount-of-dollars-paid-during-the-pay-periods': 'Cantidad de dólares pagados durante el período de pago',
    'start-date': 'Fecha de Inicio',
    'end-date': 'Fecha de Fin',
    'pay-periods': 'Períodos de Pago',
    'start-of-new-pay-rate-and-job-title-code': 'Inicio de nueva tarifa de pago y código de título de trabajo',
    'pay-rate': 'Tarifa de Pago',
    'prior-pay-rate': 'Tarifa de Pago Anterior',
    'job-title-code': 'Código de Título de Trabajo',
    'prior-job-title-code': 'Código de Título de Trabajo Anterior',
    'start-of-leave-of-absence': 'Inicio de la licencia',
    'projected-return': 'Regreso Proyectado',
    'projected-return-of-leave-of-absence': 'Regreso proyectado de la licencia',
    'actual-return': 'Regreso Actual',
    'actual-return-of-leave-of-absence': 'Regreso real de la licencia',
    'reason': 'Razón',
    'job-title-code-description-description': 'Descripción del código de título de trabajo de McDonalds',
    'job-title-code-description-header': 'Descripción del código de título de trabajo',
    'date-of-birth-header': 'Fecha de Nacimiento',
    'date-of-birth-description': 'Fecha de nacimiento del empleado',
    'street-address': 'Dirección',
    'city': 'Ciudad',
    'zip-code': 'Código Postal',
    'apt-number': 'Número de Apartamento',
    'error-loading-report': 'Hubo un error al cargar el informe.',
    'pay-period-end-date': 'Fecha de Fin del Período de Pago',
    'payroll-ledger': 'Libro Mayor de Nómina',
    'omit-managers': 'Omitir Gerentes',
    'show-documents-expiring-in-the-next': 'Mostrar Documentos que Expiran en los Próximos',
    'day-scope': 'Día(s)',
    'week-scope': 'Semana(s)',
    'month-scope': 'Mes(es)',
    'scope': 'Ámbito',
    'student-permit-status-check': 'Verificación del Estado del Permiso Estudiantil',
    'date': 'Fecha',
    'less-than-20': 'Menos de 20',
  },
  // These reports carry US payroll fields (SSN, federal/state withholding, W-4
  // dependents). The acronyms are kept as-is in both French locales because
  // they name the actual source data, not a local equivalent.
  fr: {
    'all': 'Tous',
    'avg-weekly-hrs': 'Moy. heures hebdo',
    'only-active': 'Actifs uniquement',
    'employee-look-back': 'Historique des employés',
    'search-here': 'Rechercher ici',
    'search-instructions': 'Recherchez à l’aide des 4 premières lettres du nom de famille de l’employé OU des 4 derniers chiffres de son SSN. Pour les noms de moins de 4 lettres, ajoutez des espaces pour atteindre 4 caractères.',
    'employee-lookup': 'Pointages des employés',
    'please-enter-a-value': 'Veuillez saisir une valeur',
    'please-enter-4-letters': 'Veuillez saisir 4 lettres',
    'please-enter-4-numbers': 'Veuillez saisir 4 chiffres',
    'please-do-not-use-special-characters': 'Veuillez ne pas utiliser de caractères spéciaux',
    'employees': 'Employés',
    'emp-pay-details': 'Détails de rémunération de l’employé',
    'federal': 'Féd.',
    'state': 'État',
    'local': 'Local',
    'marital-status': 'Situation familiale',
    'tax-exempt': 'Exonéré d’impôt',
    'exemptions': 'Exonérations',
    'additional-withholding': 'Retenue supplémentaire $',
    'fed-multi-job': 'Féd. emplois multiples',
    'fed-qual-child': 'Féd. enfant éligible $',
    'fed-other-dep': 'Féd. autres pers. à charge $',
    'fed-total-dep': 'Féd. total pers. à charge $',
    'fed-other-income': 'Féd. autres revenus',
    'fed-deductions': 'Féd. déductions',
    'hire-card-store-num': 'Site',
    'new-hires-since': 'Nouvelles embauches depuis',
    'new-hires-found': 'Nouvelles embauches trouvées',
    'new-hires': 'Nouvelles embauches',
    'overtime-audit': 'Audit des heures supplémentaires',
    'no-pay-details-found': 'Aucun détail de rémunération n’a été trouvé.',
    'pay-cycle': 'Cycle de paie',
    'pay-cycle-status': 'Statut du cycle de paie',
    'current-pay-cycle': 'Cycle de paie en cours',
    'most-recent-released': 'Dernier cycle publié',
    'next-pay-cycle': 'Prochain cycle de paie',
    'active-employee-with-no-punches': 'Employé actif sans pointage',
    'employee-terminations': 'Départs des employés',
    'employee-pay-rate-change': 'Changement de taux de rémunération',
    'employee-leave-of-absence': 'Congé de l’employé',
    'total-employees': 'Total des employés',
    'employee-name': 'Nom de l’employé',
    'employee-full-name': 'Nom complet de l’employé, y compris l’initiale du deuxième prénom si elle est renseignée',
    'first-name': 'Prénom',
    'employee-first-name': 'Prénom de l’employé',
    'last-name': 'Nom de famille',
    'employee-last-name': 'Nom de famille de l’employé',
    'ssn': 'SSN',
    'employee-ssn': 'Numéro de sécurité sociale de l’employé',
    'geid': 'GEID',
    'employee-geid': 'Identifiant global d’employé McDonald’s',
    'primary-badge': 'Badge principal',
    'primary-badge-number': 'Numéro du badge principal',
    'secondary-badge': 'Badge secondaire',
    'secondary-badge-number': 'Numéro du badge secondaire',
    'last-punch-date': 'Date du dernier pointage',
    'last-punch-date-within-3-months': 'Dernier pointage dans les 3 derniers mois',
    'greater-than-3-months': '> 3 mois',
    'hire-date': 'Date d’embauche',
    'date-hired': 'Date d’embauche',
    'termination-date': 'Date de départ',
    'date-of-termination': 'Date de départ',
    'termination-reason': 'Motif du départ',
    'reason-of-termination': 'Motif du départ',
    'termination-code': 'Code de départ',
    'reason-of-termination-code': 'Motif du départ',
    'day-count': 'Nombre de jours',
    'double-time-hours': 'Heures payées double',
    'amount-of-hours-paid-double-the-regular-rate': 'Nombre d’heures payées au double du taux normal',
    'overtime-hours': 'Heures supplémentaires',
    'amount-of-hours-paid-pay-and-a-half': 'Nombre d’heures payées à une fois et demie le taux normal',
    'regular-time-hours': 'Heures normales',
    'amount-of-hours-paid-with-normal-pay-rate': 'Nombre d’heures payées au taux normal',
    'total-dollars-paid': 'Total des sommes versées',
    'amount-of-dollars-paid-during-the-pay-periods': 'Montant versé au cours de la ou des périodes de paie',
    'start-date': 'Date de début',
    'end-date': 'Date de fin',
    'pay-periods': 'Périodes de paie',
    'start-of-new-pay-rate-and-job-title-code': 'Début du nouveau taux de rémunération et du code de poste',
    'pay-rate': 'Taux de rémunération',
    'prior-pay-rate': 'Taux de rémunération précédent',
    'job-title-code': 'Code de poste',
    'prior-job-title-code': 'Code de poste précédent',
    'start-of-leave-of-absence': 'Début du congé',
    'projected-return': 'Retour prévu',
    'projected-return-of-leave-of-absence': 'Retour prévu du congé',
    'actual-return': 'Retour effectif',
    'actual-return-of-leave-of-absence': 'Retour effectif du congé',
    'reason': 'Motif',
    'job-title-code-description-description': 'Description du code de poste McDonald’s',
    'job-title-code-description-header': 'Description du code de poste',
    'date-of-birth-header': 'Date de naissance',
    'date-of-birth-description': 'Date de naissance de l’employé',
    'street-address': 'Adresse',
    'city': 'Ville',
    'zip-code': 'Code postal',
    'apt-number': 'N° d’appartement',
    'error-loading-report': 'Une erreur s’est produite lors du chargement du rapport.',
    'pay-period-end-date': 'Date de fin de la période de paie',
    'payroll-ledger': 'Journal de paie',
    'omit-managers': 'Exclure les managers',
    'show-documents-expiring-in-the-next': 'Afficher les documents expirant dans les',
    'day-scope': 'Jour(s)',
    'week-scope': 'Semaine(s)',
    'month-scope': 'Mois',
    'scope': 'Portée',
    'student-permit-status-check': 'Vérification du statut du permis étudiant',
    'date': 'Date',
    'less-than-20': 'Moins de 20',
  },
  'fr-ca': {
    'all': 'Tous',
    'avg-weekly-hrs': 'Moy. heures hebdo',
    'only-active': 'Actifs seulement',
    'employee-look-back': 'Historique des employés',
    'search-here': 'Rechercher ici',
    'search-instructions': 'Effectuez votre recherche à l’aide des 4 premières lettres du nom de famille de l’employé OU des 4 derniers chiffres de son SSN. Pour les noms de moins de 4 lettres, ajoutez des espaces pour atteindre 4 caractères.',
    'employee-lookup': 'Poinçons des employés',
    'please-enter-a-value': 'Veuillez saisir une valeur',
    'please-enter-4-letters': 'Veuillez saisir 4 lettres',
    'please-enter-4-numbers': 'Veuillez saisir 4 chiffres',
    'please-do-not-use-special-characters': 'Veuillez ne pas utiliser de caractères spéciaux',
    'employees': 'Employés',
    'emp-pay-details': 'Détails de la paie de l’employé',
    'federal': 'Féd.',
    'state': 'État',
    'local': 'Local',
    'marital-status': 'État civil',
    'tax-exempt': 'Exempté d’impôt',
    'exemptions': 'Exemptions',
    'additional-withholding': 'Retenue supplémentaire $',
    'fed-multi-job': 'Féd. emplois multiples',
    'fed-qual-child': 'Féd. enfant admissible $',
    'fed-other-dep': 'Féd. autres personnes à charge $',
    'fed-total-dep': 'Féd. total personnes à charge $',
    'fed-other-income': 'Féd. autres revenus',
    'fed-deductions': 'Féd. déductions',
    'hire-card-store-num': 'Emplacement',
    'new-hires-since': 'Nouvelles embauches depuis',
    'new-hires-found': 'Nouvelles embauches trouvées',
    'new-hires': 'Nouvelles embauches',
    'overtime-audit': 'Audit du temps supplémentaire',
    'no-pay-details-found': 'Aucun détail de paie n’a été trouvé.',
    'pay-cycle': 'Cycle de paie',
    'pay-cycle-status': 'Statut du cycle de paie',
    'current-pay-cycle': 'Cycle de paie en cours',
    'most-recent-released': 'Dernier cycle publié',
    'next-pay-cycle': 'Prochain cycle de paie',
    'active-employee-with-no-punches': 'Employé actif sans poinçon',
    'employee-terminations': 'Cessations d’emploi',
    'employee-pay-rate-change': 'Changement du taux de rémunération de l’employé',
    'employee-leave-of-absence': 'Congé autorisé de l’employé',
    'total-employees': 'Total des employés',
    'employee-name': 'Nom de l’employé',
    'employee-full-name': 'Nom complet de l’employé, y compris l’initiale du second prénom si elle est saisie',
    'first-name': 'Prénom',
    'employee-first-name': 'Prénom de l’employé',
    'last-name': 'Nom de famille',
    'employee-last-name': 'Nom de famille de l’employé',
    'ssn': 'SSN',
    'employee-ssn': 'Numéro de sécurité sociale de l’employé',
    'geid': 'GEID',
    'employee-geid': 'Identifiant mondial d’employé McDonald’s',
    'primary-badge': 'Badge principal',
    'primary-badge-number': 'Numéro du badge principal',
    'secondary-badge': 'Badge secondaire',
    'secondary-badge-number': 'Numéro du badge secondaire',
    'last-punch-date': 'Date du dernier poinçon',
    'last-punch-date-within-3-months': 'Dernier poinçon au cours des 3 derniers mois',
    'greater-than-3-months': '> 3 mois',
    'hire-date': 'Date d’embauche',
    'date-hired': 'Date d’embauche',
    'termination-date': 'Date de cessation d’emploi',
    'date-of-termination': 'Date de cessation d’emploi',
    'termination-reason': 'Motif de cessation d’emploi',
    'reason-of-termination': 'Motif de cessation d’emploi',
    'termination-code': 'Code de cessation d’emploi',
    'reason-of-termination-code': 'Motif de cessation d’emploi',
    'day-count': 'Nombre de jours',
    'double-time-hours': 'Heures payées à taux double',
    'amount-of-hours-paid-double-the-regular-rate': 'Nombre d’heures payées au double du taux régulier',
    'overtime-hours': 'Heures de temps supplémentaire',
    'amount-of-hours-paid-pay-and-a-half': 'Nombre d’heures payées à taux et demi',
    'regular-time-hours': 'Heures régulières',
    'amount-of-hours-paid-with-normal-pay-rate': 'Nombre d’heures payées au taux régulier',
    'total-dollars-paid': 'Total des dollars versés',
    'amount-of-dollars-paid-during-the-pay-periods': 'Montant versé pendant la ou les périodes de paie',
    'start-date': 'Date de début',
    'end-date': 'Date de fin',
    'pay-periods': 'Périodes de paie',
    'start-of-new-pay-rate-and-job-title-code': 'Début du nouveau taux de rémunération et du code de titre d’emploi',
    'pay-rate': 'Taux de rémunération',
    'prior-pay-rate': 'Taux de rémunération antérieur',
    'job-title-code': 'Code de titre d’emploi',
    'prior-job-title-code': 'Code de titre d’emploi antérieur',
    'start-of-leave-of-absence': 'Début du congé autorisé',
    'projected-return': 'Retour prévu',
    'projected-return-of-leave-of-absence': 'Retour prévu du congé autorisé',
    'actual-return': 'Retour réel',
    'actual-return-of-leave-of-absence': 'Retour réel du congé autorisé',
    'reason': 'Motif',
    'job-title-code-description-description': 'Description du code de titre d’emploi McDonald’s',
    'job-title-code-description-header': 'Description du code de titre d’emploi',
    'date-of-birth-header': 'Date de naissance',
    'date-of-birth-description': 'Date de naissance de l’employé',
    'street-address': 'Adresse',
    'city': 'Ville',
    'zip-code': 'Code postal',
    'apt-number': 'N° d’appartement',
    'error-loading-report': 'Une erreur est survenue lors du chargement du rapport.',
    'pay-period-end-date': 'Date de fin de la période de paie',
    'payroll-ledger': 'Grand livre de la paie',
    'omit-managers': 'Exclure les gérants',
    'show-documents-expiring-in-the-next': 'Afficher les documents qui expirent dans les',
    'day-scope': 'Jour(s)',
    'week-scope': 'Semaine(s)',
    'month-scope': 'Mois',
    'scope': 'Portée',
    'student-permit-status-check': 'Vérification du statut du permis étudiant',
    'date': 'Date',
    'less-than-20': 'Moins de 20',
  },
};
